import script from "./RoleIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleIndex.vue?vue&type=script&setup=true&lang=js"

import "./RoleIndex.vue?vue&type=style&index=0&id=5539d3f2&lang=css"
import "./RoleIndex.vue?vue&type=style&index=1&id=5539d3f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5539d3f2"]])

export default __exports__